import React, { useEffect, useState } from 'react';
import { useStore } from '../states/store';
import HLBackendV1Api from '../utils/http/api';
import CountUp from 'react-countup';

function UserBetsDetails() {
    const { timerStatus, userBetsDetails } = useStore();
    //const [userBetsDetails, setUserBetsDetails] = useState();
    const [isHovering, setIsHovering] = useState(false);
    const [animateIcon, setAnimateIcon] = useState(false);

    const getUserBetsDetail = async() => {
        try {
            await HLBackendV1Api.get(`${process.env.BACKEND_API_URL}/betting-management/user-bets-details`)
            .then((response) => { 
                setUserBetsDetails(response.data)
            });
        } catch (error) {
            console.log(error)
        }
    }

    const redirectToBinance = () => {
        setAnimateIcon(true);
        setTimeout(() => setAnimateIcon(false), 1000);
        const targetUrl = 'https://www.binance.com/en/trade/BTC_USDT?type=spot';
        window.open(targetUrl, '_blank');
    };

    useEffect(() => {
        //getUserBetsDetail();
        return () => {}
    }, []);

    return (
        <div className="w-full p-2">
            <div className="flex flex-row items-center justify-between gap-1">
                
                {/* Win Ratio - Compact */}
                <div className="flex-1 group relative">
                    <div className="flex flex-col items-center px-1 py-1.5 rounded-lg hover:bg-emerald-500/10 transition-all duration-300">
                        <div className="flex items-center gap-0.5 mb-0.5">
                            <svg className="w-3 h-3 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span className="text-sm font-extrabold text-emerald-400/80 uppercase tracking-wider">
                                Win
                            </span>
                        </div>
                        
                        <span className="text-sm font-black bg-gradient-to-b from-emerald-400 to-teal-400 bg-clip-text text-transparent">
                            <CountUp 
                                end={userBetsDetails?.winRatio || 0} 
                                suffix="%" 
                                duration={2}
                                decimals={1}
                            />
                        </span>
                        
                        <span className="text-sm text-white/40 mt-0.5 truncate max-w-full">
                            24h 당첨율
                        </span>
                    </div>
                </div>

                {/* Divider */}
                <div className="w-px h-6 bg-gradient-to-b from-transparent via-white/10 to-transparent" />

                {/* Daily Players - Compact */}
                <div className="flex-1 group relative">
                    <div className="flex flex-col items-center px-1 py-1.5 rounded-lg hover:bg-blue-500/10 transition-all duration-300">
                        <div className="flex items-center gap-0.5 mb-0.5">
                            <svg className="w-3 h-3 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                            </svg>
                            <span className="text-sm font-extrabold text-blue-400/80 uppercase tracking-wider">
                                Live
                            </span>
                        </div>
                        
                        <span className="text-sm font-black text-white">
                            <CountUp 
                                end={userBetsDetails?.dailyUserCount || 0} 
                                duration={2}
                            />
                        </span>
                        
                        <span className="text-sm text-white/40 mt-0.5 truncate max-w-full">
                            24h 플레이어
                        </span>

                        {/* Live indicator dot */}
                        <span className="absolute -top-0.5 -right-0.5 flex h-1.5 w-1.5">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-blue-500"></span>
                        </span>
                    </div>
                </div>

                {/* Divider */}
                <div className="w-px h-6 bg-gradient-to-b from-transparent via-white/10 to-transparent" />

                {/* Daily Payout - Compact */}
                <div className="flex-1 group relative">
                    <div className="flex flex-col items-center px-1 py-1.5 rounded-lg hover:bg-purple-500/10 transition-all duration-300">
                        <div className="flex items-center gap-0.5 mb-0.5">
                            <svg className="w-3 h-3 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span className="text-sm font-extrabold text-purple-400/80 uppercase tracking-wider">
                                Payout
                            </span>
                        </div>
                        
                        <span className="text-sm font-black bg-gradient-to-b from-purple-400 to-pink-400 bg-clip-text text-transparent">
                            <CountUp 
                                prefix="₩" 
                                end={userBetsDetails?.dailyWinsPaid || 0} 
                                duration={2}
                                separator=","
                            />
                        </span>
                        
                        <span className="text-sm text-white/40 mt-0.5 truncate max-w-full">
                            24h 지급
                        </span>
                    </div>
                </div>

                {/* Divider */}
                <div className="w-px h-6 bg-gradient-to-b from-transparent via-white/10 to-transparent" />

                {/* Verify Button - Compact */}
                <div className="flex-none">
                    <button
                        className={`
                            relative p-1.5 rounded-md bg-gradient-to-r from-indigo-600 to-purple-600
                            hover:from-indigo-500 hover:to-purple-500
                            border border-white/10 shadow-lg shadow-indigo-500/30
                            transition-all duration-300 hover:scale-110
                            ${animateIcon ? 'animate-pulse' : ''}
                        `}
                        onClick={redirectToBinance}
                        onMouseEnter={() => setIsHovering(true)}
                        onMouseLeave={() => setIsHovering(false)}
                        title="Verify Fairness"
                    >
                        {/* Glow effect */}
                        <div className={`
                            absolute inset-0 bg-gradient-to-r from-indigo-400 to-purple-400 
                            rounded-md blur-lg transition-opacity duration-500
                            ${isHovering ? 'opacity-50' : 'opacity-0'}
                        `} />
                        
                        {/* Icon */}
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            className={`
                                relative w-3.5 h-3.5 text-white drop-shadow-lg
                                transition-all duration-300
                                ${isHovering ? 'scale-110' : ''}
                            `}
                        >
                            <path fillRule="evenodd" d="M12 2.25a.75.75 0 0 1 .75.75v.756a49.106 49.106 0 0 1 9.152 1 .75.75 0 0 1-.152 1.485h-1.918l2.474 10.124a.75.75 0 0 1-.375.84A6.723 6.723 0 0 1 18.75 18a6.723 6.723 0 0 1-3.181-.795.75.75 0 0 1-.375-.84l2.474-10.124H12.75v13.28c1.293.076 2.534.343 3.697.776a.75.75 0 0 1-.262 1.453h-8.37a.75.75 0 0 1-.262-1.453c1.162-.433 2.404-.7 3.697-.775V6.24H6.332l2.474 10.124a.75.75 0 0 1-.375.84A6.723 6.723 0 0 1 5.25 18a6.723 6.723 0 0 1-3.181-.795.75.75 0 0 1-.375-.84L4.168 6.241H2.25a.75.75 0 0 1-.152-1.485 49.105 49.105 0 0 1 9.152-1V3a.75.75 0 0 1 .75-.75Zm4.878 13.543 1.872-7.662 1.872 7.662h-3.744Zm-9.756 0L5.25 8.131l-1.872 7.662h3.744Z" clipRule="evenodd" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default UserBetsDetails;